<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="المقدمة">
<p style="text-indent:1em; margin-top:150px"><strong><span dir="rtl">* في المستقبل البعيد..</span></strong></p>
<p><span dir="rtl">كان هناك أطفالٌ صغار يلعبون على شاطئ رملي، ويبحثون عن الأصداف والمرجان، وحينما رأوا شيئًا غريبًا يطفو على سطح الماء ويرتطم باليابسة هرعوا إليه يتلقَّفوه، وقد ساوَرهم الفضول في فتح هذه العلبة البلاستيكية ومعرفة ما يوجد بداخلها.</span></p>
<p><span dir="rtl">مسحها أكبرهم بثيابه، وقام بفتحها وسط تحديق الطفلَين الآخَرين والفتاة، وجد فيها ورقة طُوِيَت بعناية ووُضِعَت فيها، وهمَّ أن يفتحها، إلا إنَّ الفتاة الصغيرة ذات الشعر الأشقر خطفَتها مِن بين يديه، وركضَت مهلِّلةً، يتبعها الأولاد بصرخاتهم، راجِين منها التوقُّف ليتمكَّنوا مِن قراءة هذه الرسالة الغامضة.</span></p>
<p><span dir="rtl">استبقوها حتَّى انقضُّوا عليها، فما كان منها إلا أن ضمّتِ الرسالة بكلتا يديها الصغيرتين، وأمرَتهم بالهدوء والرويَّة كي تتمكَّن مِن فتحها وقراءتها لهم.</span></p>
<p><span dir="rtl">وبعد أن امتثلوا لأوامرها فتحَتِ الورقة، ففوجئوا جميعًا بأنها مكتوبة بلغة غريبة وغير مفهومة، فخاب أملهم، وانفضُّوا مِن حول الفتاة، إلَّا إنَّ كبيرهم ذا العيون اللوزية قال بعزم: انتظِروا، قد يكون صاحب الرسالة في خطر، علينا أن نحاول فكَّ هذه الشفرة ومعرفة ما كُتِب فيها.</span></p>
<p><span dir="rtl">فقال الولد الأصغر وقد ظهر عليه الاهتمام: لكن كيف؟</span></p>
<p><span dir="rtl">- لنذهب إلى كبير القرية؛ فقد أخبرني ذات مرَّة أنَّه يعرف الكثير مِن اللغات.</span></p>
<p><span dir="rtl">طوَتِ الفتاة الشقراء الرسالة، وقالت بعزم: هيَّا بنا.</span></p>
<p><span dir="rtl">غاب الأطفال خلف الشجيرات يشقُّون طريقهم لقريتهم الصغيرة، باحثين عن ذاك العجوز الذي سيحلُّ لُغزهم الصغير، ويثلج صدورهم بفحوى تلك الرسالة التي جاءتهم مِن عمق البحر.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?00c21fae